import React, { useState, useEffect } from 'react';
import { GridTable, SecondaryHeader, SecondaryHeaderInfo, SecondaryHeaderSearchField, Spinner } from 'react-myoneui';
import ShowFilterOffCanvas from 'modules/admin/applicantRegistration/applicants/ShowFilterOffCanvas';
import { translate } from 'lib';
import { useSelector } from 'react-redux';
import { clearBtn } from 'constants/icons';
import PaginationTemplate from 'components/grid-table/PaginationTemplate';
import { getMyApplicants } from 'api';
import LearnerNameTemplate from 'components/grid-table/LearnerNameTemplate';
import TextCol from 'components/grid-table/TextCol';
import StatusCol from 'components/grid-table/StatusCol';
import ls from 'localstorage-slim';
import Log from 'lib/Log';
import DataNotFound from 'components/DataNotFound';
import CustomiseHeaderTemplate from './grid-table/CustomiseHeaderTemplate';

const Applicants = () => {
  const [displayResetFilter, setDisplayResetFilter] = useState(false);
  const [resetFilter, setResetFilter] = useState(false);
  const [filterData, setFilterData] = useState({});
  const [search, setSearch] = useState('');
  const lang = useSelector((state) => state?.lang?.data);
  const parent_id = ls.get('parent_id');
  const idp_id = ls.get('account_id');
  //const idp_id = 555;
  const columnData = [
    // {
    //   id: 'checkbox',
    //   pinned: true,
    //   className: 'selectAll',
    //   width: '55px',
    //   minResizeWidth: 0,
    //   maxResizeWidth: null,
    //   resizable: false,
    //   visible: true,
    // },
    {
      id: 1,
      field: 'full_name',
      visible: true,
      label: `Applicant Name`,
      width: '1fr',
      sortable: true,
      cellRenderer: LearnerNameTemplate,
    },
    {
      id: 2,
      field: 'email',
      visible: true,
      label: `Email`,
      width: '1fr',
      sortable: true,
      cellRenderer: TextCol,
    },
    {
      id: 3,
      field: 'contact',
      visible: true,
      label: `Contact No.`,
      width: '1fr',
      sortable: true,
      cellRenderer: TextCol,
    },
    {
      id: 3,
      field: 'flow',
      visible: true,
      label: `Registration Flow`,
      width: '1fr',
      sortable: true,
      cellRenderer: TextCol,
    },
    {
      id: 4,
      field: 'appliedFor',
      visible: true,
      label: `Applied For`,
      width: '1.5fr',
      sortable: true,
      cellRenderer: TextCol,
    },
    // {
    //   id: 3,
    //   field: 'status',
    //   visible: true,
    //   label: `Status`,
    //   width: '1fr',
    //   sortable: true,
    //   cellRenderer: StatusCol,
    // },
    // {
    //   id: '4',
    //   width: '.5fr',
    //   sortable: false,
    //   resizable: false,
    //   headerCellRenderer: CustomiseHeaderTemplate,
    //   cellRenderer: ({ value }) => (
    //     <div
    //       className="rgt-cell-inner rgt-text-truncate program-edit-hover justify-content-center"
    //       title={value}
    //     >
    //       <Button
    //         variant="white"
    //         className="btn-round"
    //       >
    //         Approve
    //       </Button>
    //     </div>
    //   ),
    // },
    {
      id: '4',
      field: 'status',
      label: '',
      width: '.8fr',
      sortable: false,
      resizable: false,
      cellRenderer: (data) => (
        <CustomiseHeaderTemplate
          onRowsRequest={onRowsRequest}
          {...data}
        />
      ),
    },
  ];

  const onSearchChange = (e) => {
    setSearch(e.target.value);
  };
  const onClearSearch = () => {
    setSearch('');
  };

  // api call

  const organisationId = ls.get('orgId');
  const token = ls.get('token');

  const [data, setData] = useState([]);
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);
  const [perPage, setPerPage] = useState(15);
  const [currentPage, setCurrentPage] = useState(1);
  const [sort, setSort] = useState('asc');
  const [sortBy, setSortBy] = useState('createdAt');
  const [activeColId, setActiveColId] = useState('checkbox');

  const sortHandler = ({ colId, isAsc }) => {
    setSort(isAsc ? 'asc' : 'desc');
    if (colId) {
      const sortCol = columnData.find((colData) => colData.id === colId);
      setActiveColId(sortCol.id);
      setSortBy(sortCol.field);
    } else {
      setActiveColId('1');
      setSortBy('createdAt');
      setSort('desc');
    }
    setPerPage(15);
    setCurrentPage(1);
  };

  const onRowsRequest = async () => {
    try {
      setData(null);
      setTotalData(null);
      setLoading(true);
      const payload = {
        orgId: organisationId,
        perPage: perPage,
        currentPage: currentPage,
        search_keyword: search,
        token: token,
        sort: sort,
        sortBy: sortBy,
        parent_id: parent_id,
        // ...(parent_id ? { idp_id } : {}),
        idp_id,
        ...filterData,
      };
      if (organisationId && loading === false) {
        const result = await getMyApplicants(payload);
        if (result) {
          setLoading(false);
          const formattedData = result?.data?.data?.data?.map((list) => ({
            ...list,
            full_name: list?.applicantName,
            email: list?.applicantEmail,
            contact: list?.applicantPhone,
            appliedFor: list?.applicantInterestApprenticeshipId?.name,
            flow: list?.flowName,
          }));
          setData(formattedData);
          setTotalData(result?.data.data?.meta?.totalData);
          return {
            rows: formattedData,
            totalRows: result?.data.data?.meta?.totalData,
          };
        }
      }
    } catch (e) {
      Log.error('Error on onRowsRequest', e);
      setLoading(false);
      setData([]);
      setTotalData(0);
    }
  };

  useEffect(() => {
    if (search.length > 0) {
      setTimeout(() => {
        onRowsRequest();
      }, 500);
    } else {
      onRowsRequest();
    }
  }, [search, perPage, currentPage, sort, sortBy, filterData]);

  return (
    <div className="content-wrapper">
      <SecondaryHeader>
        <div className="secondary-header-wrap">
          <SecondaryHeaderInfo
            SecondaryHeaderTitle="Applicants"
            // SecondaryHeaderText={`${totalData} Users`}
            SecondaryText
          />
        </div>
        <SecondaryHeaderSearchField
          placeholder="Search applicant"
          value={search}
          onChange={onSearchChange}
          onClear={onClearSearch}
        />
        <div></div>
      </SecondaryHeader>
      <div className="filter-block">
        <ShowFilterOffCanvas
          triggerTitle={translate(lang)('show_filters')}
          applyFilter={(data) => {
            let filter = {};
            if (data?.program) {
              filter.program = data?.program?.id;
            }
            if (Object.entries(filter).length > 0) {
              setDisplayResetFilter(true);
            } else {
              setDisplayResetFilter(false);
            }
            setFilterData(filter);
          }}
          updateResetFilter={() => {
            setResetFilter(false);
          }}
          formCleared={() => {
            setFilterData({});
            setDisplayResetFilter(false);
          }}
          resetFilter={resetFilter}
        />
        {displayResetFilter && (
          <span
            className="clear-filter"
            onClick={() => {
              setResetFilter(true);
              setFilterData({});
              setDisplayResetFilter(false);
            }}
          >
            {clearBtn}
            Clear Filters
          </span>
        )}
      </div>

      <div className="content-block px-0 py-2">
        {loading ? (
          <div className="spinner-wrapper">
            <Spinner animation="border" />
          </div>
        ) : data && data.length > 0 && totalData ? (
          <GridTable
            className="program-grid unit-grid"
            columns={columnData}
            onSortChange={(sortData) => sortHandler(sortData)}
            sort={{ colId: activeColId, isAsc: sort === 'asc' ? true : false }}
            onRowsRequest={() => {
              return {
                rows: data,
                totalRows: totalData,
              };
            }}
            components={{ Footer: PaginationTemplate }}
            page={currentPage}
            pageSize={perPage}
            onPageChange={(page) => setCurrentPage(page)}
            onPageSizeChange={(data) => {
              setCurrentPage(1);
              return setPerPage(data);
            }}
          />
        ) : (
          !loading && data?.length === 0 && <DataNotFound title="Applicant" />
        )}
      </div>
    </div>
  );
};

export default Applicants;
